import { Box, Stack, useTheme } from "@mui/material";
import { FC, ReactNode, useState } from "react";
import Footer from "../components/footer";

type Props = {
	fixedChildren?: ReactNode;
	scrollableChildren: ReactNode;
	disableFooter?: boolean;
	miniFooter?: boolean;
};

const ScreenBase: FC<Props> = ({ fixedChildren, scrollableChildren, disableFooter, miniFooter }) => {
	const theme = useTheme();
	const [fixedHeight, setFixedHeight] = useState(0);

	const fixedBox = (element: HTMLDivElement | null) => {
		if (element) {
			setFixedHeight(element.clientHeight);
		}
	};

	return (
		<Stack id="screenBase" spacing={2} position="relative">
			{fixedChildren && (
				<Box
					ref={fixedBox}
					sx={{
						position: 'fixed',
						left: 0,
						right: 0,
						ml: { xs: '16px !important', sm: '16px !important', md: '264px !important', lg: 'calc(8.333% + 232px) !important', xl: 'calc(16.667% + 232px) !important' },
						mr: { xs: '16px !important', sm: '16px !important', md: '32px !important', lg: '8.333% !important', xl: '16.667% !important' },
						backgroundColor: theme.palette.background.default,
						pb: 2,
						zIndex: 2
					}}
				>
					{fixedChildren}
				</Box>
			)}
			<Box sx={{ mt: `${fixedHeight}px !important` }}>
				<Stack height="100%" justifyContent="space-between">
					{scrollableChildren}
					{!disableFooter && (
						<Footer minimal={miniFooter} />
					)}
				</Stack>
			</Box>
		</Stack>
	);
};

export default ScreenBase;
